export default __webpack_public_path__ + "static/media/238.cda32f42.svg";